export default class EventsDetailPage {
    private $holder: JQuery;
    private readonly $stickyFooterContainer: JQuery;
    private readonly $sideCardContent: JQuery;
    private readonly $headerContainer: JQuery;
    private readonly $footerContainer: JQuery;

    private isStickyFooterElementsExists: boolean = false;

    private readonly selectors = {
        stickyFooterContainer: '.js-event-detail-sticky-footer',
        sideCardContent: '.js-events-detail-side-card',
        headerContainer: '.js-header',
        footerContainer: '.js-footer',
    };

    constructor($holder: JQuery) {
        this.$holder = $holder;
        this.$stickyFooterContainer = this.$holder.find(this.selectors.stickyFooterContainer);
        this.$sideCardContent = this.$holder.find(this.selectors.sideCardContent);
        this.$headerContainer = this.$holder.find(this.selectors.headerContainer);
        this.$footerContainer = this.$holder.find(this.selectors.footerContainer);

        this.isStickyFooterElementsExists = !!(this.$stickyFooterContainer.length && this.$sideCardContent.length);

        this.changeVisibilityStickyFooterHandler = this.changeVisibilityStickyFooterHandler.bind(this);

        void this.init();
    }

    /**
     * Инициализация страницы
     * @private
     */
    private async init() {
        this.initEvents();
    }

    /**
     * Инициализация событий на странице
     * @private
     */
    private initEvents(): void {
        if (this.isStickyFooterElementsExists) {
            this.changeVisibilityStickyFooterHandler();
            $(window).on('scroll', this.changeVisibilityStickyFooterHandler);
        }
    }

    /**
     * Функция обработчик скрола для появления/скрытия липкого футера для отображения информации о мероприятии из side-card
     * @private
     */
    private changeVisibilityStickyFooterHandler(): void {
        const footerTopPoint = this.$footerContainer.offset().top;
        const stickyFooterHeight = this.$stickyFooterContainer.innerHeight();
        const visibleFooter = footerTopPoint - stickyFooterHeight;

        const scrollY = window.scrollY;
        const sideCardContentFullHeight = this.$sideCardContent.innerHeight() + this.$sideCardContent.offset().top - this.$headerContainer.innerHeight();

        if (scrollY >= sideCardContentFullHeight && scrollY < visibleFooter) {
            this.$stickyFooterContainer.addClass('active');
        } else {
            this.$stickyFooterContainer.removeClass('active');
        }
    }
}
